import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { Circle } from 'page/catalog/Circle/Circle'
import { boutique } from 'page/catalog/employee/store/BoutiqueController'
import { demo } from 'page/catalog/store/CatalogStore'
import { user } from 'page/catalog/store/UserStore'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'
import { addRecentCustomer, Client } from 'type/client'
import { formatPhone } from 'util/phone'
import { emdash } from 'util/typo'

type Props = {
  data: Client
}

export const UserItem = observer(({ data }: Props) => {
  const be = demo.it.by_email
  const bc = demo.it.by_card
  const { name, phone, email, card, picture } = data ?? {}
  const info = be ? email : bc ? card : formatPhone(phone)

  const onChoose = useLatestCallback(async () => {
    const client = boutique.createClient(data)
    if (!client) return

    addRecentCustomer(client.employee_id, client.data)
    user.open(client)
    userModal.close()
  })

  return <Button gap={8} pad={8} height={48} left action={onChoose}>
    <Circle size={32} image={picture} icon="person" />
    <Vertical gap={4}>
      <Typo size={11} one upper medium>
        {name || emdash}
      </Typo>
      <Typo size={11} one secondary>
        {info || emdash}
      </Typo>
    </Vertical>
  </Button>
})
